const legacyNames = {
  'flight training': 'Flight Training',
  'ground training': 'Ground lesson',
  'ground lesson': 'Ground lesson',
  'discovery flight': 'Discovery',
  discovery: 'Discovery',
  checkride: 'Checkride',
  solo: 'Solo',
  rental: 'Rental'
};

export const legacyReservationType = name => legacyNames[String(name || '').trim().toLowerCase()] || name || '';

export const findReservationType = (types, form) => {
  if (form.reservationTypeId != null && form.reservationTypeId !== '') {
    return types.find(type => String(type.id) === String(form.reservationTypeId));
  }
  return types.find(type => legacyReservationType(type.name) === legacyReservationType(form.type));
};

export const applyReservationDuration = (form, type) => {
  if (!form.date || !form.time || type?.duration == null || type.duration === '') return form;
  const durationHours = Number(type.duration);
  if (!Number.isFinite(durationHours) || durationHours <= 0) return form;
  const end = new Date(`${form.date}T${form.time}:00Z`);
  if (!Number.isFinite(end.getTime())) return form;
  end.setUTCMinutes(end.getUTCMinutes() + Math.round(durationHours * 60));
  return { ...form, endDate: end.toISOString().slice(0, 10), endTime: end.toISOString().slice(11, 16) };
};